module.exports = __webpack_public_path__ + "static/media/HCMM614.13c38b22.jpg";